module.exports = __webpack_public_path__ + "img/img1.53e94174.png";